import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router'
import { getUserByID } from '../../api/auth';
import './index.sass'

export default function ImageCard({ isLocked, img, type, userId, postId, thumb }) {
    const history = useHistory();

    const gotoPost = async () => {
        // history.push({
        //     pathname: (type == 1) ? `/post/${postId}/img` : `/post/${postId}/mp4`
        // })
        const user = await getUserByID(userId);
        history.push({
            pathname: `/${user.username}/explore/posts`,
            state: {postId: postId}
        })
        
    }

    return (
        <div className='explore-post-card' onClick={gotoPost}>
            <div className={isLocked ? 'profile-post-locked' : ''}>
                {isLocked ? <div className="profile-post-lock-button">
                    {type == 1 && <img src={thumb} />}
                    {type == 2 && <video controls src={img} />}

                    <p>$66</p>
                </div> : <div> </div>}
                {type == 1 && <img className={`${isLocked ? 'profile-post-image-locked' : 'profile-post-image'}`} src={thumb} />}
                {type == 2 && <video autoplay controls loop muted className={`${isLocked ? 'profile-post-image-locked' : 'profile-post-image'}`} src={img} />}
 

            </div>
        </div>
    )
}
